'use client';

import { createContext, useContext } from 'react';

import { CoveoEngineContextValue } from './CoveoEngineContext';

export const CoveoListingContext = createContext<CoveoEngineContextValue>({
  searchEngine: undefined,
  coveoContext: undefined,
});

export const useCoveoListingContext = () => {
  const coveoListContext = useContext(CoveoListingContext);
  return coveoListContext;
};
